import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import { ratingMaximum, ratingMinimum } from '../../../../constants/jobs';
import { favStatuses } from '../../../../constants/workers';

export default class AddToCompanyWorkers extends PureComponent {
  wrapperClassList = 'mt-4 d-flex align-items-center justify-content-center';

  isMaximumRating = () => this.props.rating === ratingMaximum;

  isMinimumRating = () => this.props.rating === ratingMinimum;

  shouldAddToCompanyWorkers = () => this.isMaximumRating() || this.isMinimumRating();

  shouldAddToFavorites = () => this.isMaximumRating() && this.props.isWorkersToAddFavorite;

  handleFavStatus = status => this.props.handleFavStatus(status);

  render () {
    if (!this.shouldAddToCompanyWorkers()) {
      return null;
    }

    if (this.shouldAddToFavorites()) {
      return (
        <div className={this.wrapperClassList}>
          <Switch
            onChange={() => this.handleFavStatus(favStatuses.favorite)}
            checked={this.props.fav_status === favStatuses.favorite}
            onColor='#68ca59'
            uncheckedIcon={false}
            checkedIcon={false}
            width={35}
            height={19}
          />

          <button
            className='ml-2 button-pristine text-left'
            children='Would you like to add worker(s) to your list of favorite?'
            onClick={() => this.handleFavStatus(favStatuses.favorite)}
          />
        </div>
      );
    }

    if (this.isMinimumRating()) {
      return (
        <div className={this.wrapperClassList}>
          <Switch
            onChange={() => this.handleFavStatus(favStatuses.blocked)}
            checked={this.props.fav_status === favStatuses.blocked}
            onColor='#68ca59'
            uncheckedIcon={false}
            checkedIcon={false}
            width={35}
            height={19}
          />

          <button
            className='ml-2 button-pristine text-left'
            children='Would you like to prevent worker(s) from working for you again?'
            onClick={() => this.handleFavStatus(favStatuses.blocked)}
          />
        </div>
      );
    }

    return null;
  }
}

AddToCompanyWorkers.propTypes = {
  rating: PropTypes.number,
  isWorkersToAddFavorite: PropTypes.bool,
  handleFavStatus: PropTypes.func,
  fav_status: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ])
};



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/AddToCompanyWorkers.js